/**
 * @copyright   2010-2015, The Titon Project
 * @license     http://opensource.org/licenses/BSD-3-Clause
 * @link        http://titon.io
 */

define([
    './clickout',
    './horizontal-resize',
    './swipe',
    './vertical-resize'
], function() {
    // An empty file that includes all events into the jQuery scope.
    // It does not return a value.
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/titon-toolkit/js/events/index.js
// module id = 429
// module chunks = 1